var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.taskData.created && !_vm.taskData.editing)?_c('vue-admin-tasks-saved-task-card',{attrs:{"task-data":_vm.taskData}}):_c('vue-admin-tasks-form-task-card',{attrs:{"task-data":_vm.taskData}})}
var staticRenderFns = []

export { render, staticRenderFns }